import { Star, StarBorder } from '@mui/icons-material'
import { IconButton } from '@mui/material'

type HighlightIconProps = {
  id: number
  isHighlight: boolean
  handleClick: (id: number, isHighlight: boolean) => void
}

function HighlightIcon({ id, isHighlight, handleClick }: HighlightIconProps) {
  return (
    <IconButton
      aria-controls="share-link-menu"
      aria-haspopup="false"
      aria-label="highlight"
      style={{ padding: '0px', marginBottom: '3px' }}
      onClick={() => handleClick(id, isHighlight)}
    >
      {isHighlight ? <Star htmlColor={'#FDDD35'} fontSize="small" /> : <StarBorder fontSize="small" />}
    </IconButton>
  )
}

export default HighlightIcon
